import clsx from 'clsx';
import { forwardRef } from 'react';

import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';
import { WithChildren } from '../../core/types/with-children.js';
import { Flex } from '../../layouts/flex/Flex.js';
import * as styles from './ChipKey.sty.js';

//#region Typings
/**
 * Accepted properties for the Key.
 * @public
 */
export type ChipKeyProps = WithChildren & StylingProps & DataTestId;
//#endregion

/**
 * Component used for adding elements to the key slot.
 * @public
 */
export const ChipKey = /* @__PURE__ */ forwardRef<HTMLDivElement, ChipKeyProps>(
  (props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
    }: ChipKeyProps = props;

    return (
      <Flex
        alignSelf="stretch"
        alignItems="center"
        minWidth={0}
        ref={forwardedRef}
        data-testid={dataTestId}
        gap={2}
        className={clsx(consumerClassName, styles.key)}
        style={consumerStyle}
      >
        {children}
      </Flex>
    );
  },
);

(ChipKey as typeof ChipKey & { displayName: string }).displayName = 'Chip.Key';
